
import styled from 'styled-components';
import { maxMobile, primaryFont, wMedium } from '../../../Utils/utilsStyle';
import { Divider } from 'antd';
import { useSelector } from 'react-redux';
import { selectProductAndServicesLoading } from '../../../Selector/CompaniesSelector';
import SkeletonCustom from '../../common/skeleton/SkeletonCustom';
const Wrapper = styled.div`
    background-color:#fff;
    border-radius: 16px;
    box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.04);
    border-radius:16px;
    position: relative;
    margin-bottom: 21px;
    padding: 16px 22px;
    .product-service-skeleton {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 25px;
    }
    .product-service-head {
      display: flex;
      align-items: center;
      gap: 7px;
      .head-text {
        font-family: ${primaryFont};
        font-size: 20px;
        font-weight: ${wMedium};
        line-height: normal;
        letter-spacing: -0.455px;
        color: #424B50;
        @media all and (max-width: ${maxMobile}) {
          font-size: 18px;
        }
      }
    }
    .content-container {
    padding: 16px 0;
      .content-item {
        display: flex;
        flex-direction: column;
        .content-title {
          color: #424B50;
          font-size: 16px;
          line-height: 26px;
          letter-spacing: -0.375px;
          font-weight: ${wMedium};
          font-family: ${primaryFont};
          margin-bottom: 6px;
          @media all and (max-width: ${maxMobile}) {
            font-size: 14px;
            line-height: 18px;
            letter-spacing: -0.375px;
          }
        }
        .content-description {
          font-size: 14px;
          line-height: 18px;
          letter-spacing: -0.375px;
          font-weight: ${wMedium};
          color: #7E7E7E;
          font-family: ${primaryFont};
          @media all and (max-width: ${maxMobile}) {
            font-size: 13px;
            line-height: 16px;
          }
        }
        .separator {
          color: #B6B6B6;
          margin: 16px 0;
        }
      }
    }
`;
type ProductServiceItem = {
  name: string;
  description: string;
};

type Props = {
  title: string,
  icon: React.ReactNode,
  items: ProductServiceItem[]
}
const ProductServiceCard = function ProductServiceCard(props: Props) {
  const { title, icon, items } = props;
  const productAndServicesLoading = useSelector(selectProductAndServicesLoading);
  return (
    <Wrapper>
      {productAndServicesLoading ? (
        [1, 2, 3, 4].map(() => (
          <div className='product-service-skeleton'>
            <SkeletonCustom width="240px" height="35px" margin="0px" />
            <SkeletonCustom width="100%" height="30px" margin="0px" />

          </div>
        ))
      ) : (
        <>
          <div className="product-service-head">
            {icon}
            <span className="head-text">{title}</span>
          </div>
          <div className="content-container">
            {items.map((item, index) => (
              <div className="content-item" key={item.name}>
                <h4 className="content-title">{item.name}</h4>
                <span className="content-description">{item.description}</span>

                {index < items.length - 1 && (
                  <Divider className="separator" />
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </Wrapper>
  )
}

export default ProductServiceCard;